import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { startLogin } from '../../src/redux/actions/LoginActions';
import { connect } from "react-redux";
import { useAuth } from '../../src/utils/Auth';
import axios from 'axios';

const LoginComponent = (props) => {

    // const navigate = useNavigate();
    // const auth = useAuth();
    // const location = useLocation();


    // const [username, setUsername] = useState('')
    // const [password, setPassword] = useState('')

    // const [validUser, setValidUser] = useState(true);
    // const [validPassword, setValidPassword] = useState(true)
    // const [loader, setLoader] = useState(false);

    // const [showPassword, setShowPassword] = useState(false);

    // const [user, setUser] = useState({ username: '', password: '' });
    // const [msg, setMsg] = useState('');
    // const [ipAddress, setIpAddress] = useState('')

    // const [userAgent, setUserAgent] = useState('')
    // const [platform, setPlatform] = useState('')
    // const [language, setLanguage] = useState('')
    // const [os, setOS] = useState('')


    // const handleChange = (event) => {

    //     if (event.target.name === 'username') {
    //         setValidUser(true)
    //         setUsername(event.target.value)
    //     }
    //     if (event.target.name === 'password') {
    //         setValidPassword(true)
    //         setPassword(event.target.value)
    //     }
    // }




    // useEffect(() => {
    //     const fetchIp = async () => {
    //       try {
    //         const res = await axios.get('https://ipapi.co/json/');
    //         console.log('IP : ', res.data)
    //         setIpAddress(res.data.ip);
    //       } catch (error) {
    //         console.error('Error fetching IP:', error);
    //       }
    //     };
    //     fetchIp();
    //   }, []);


    // const redirectPath = location.state?.pathname || '/'


    // useEffect(() => {
    //     setLoader(false);
    // }, []);

    // useEffect(() => {
    //     if (props.LOGINREDUCER.ISAUTH) {
    //         auth.login({ ...props.LOGINREDUCER.USER })
    //         navigate(redirectPath)
            
    //     } else {
    //         navigate('/login')
    //     }
    //     setLoader(false);
    // }, [props.LOGINREDUCER])


    // const handleSubmit = (event) => {
    //     event.preventDefault();
    //     let params = {
    //         username: username,
    //         password: password,
    //         os: osName,
    //         ipAddress: ipAddress,
    //         platform: browserName

    //     }

    //     if (username && username.length && password && password.length) {
    //         setLoader(true);
    //         props.startLogin(params)

    //     } else {
    //         if (!username && !username.length) {
    //             setValidUser(false);
    //         }
    //         if (!password && !password.length) {
    //             setValidPassword(false)
    //         }
    //     }
    // }

    
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const [, setValidUser] = useState(true);
    const [, setValidPassword] = useState(true)
    const [, setLoader] = useState(false);
    const [showPassword, setShowPassword] = useState(false);


    const [ipAddress, setIpAddress] = useState('');
    const [userAgent, setUserAgent] = useState('');
    const [platform, setPlatform] = useState('');
    const [language, setLanguage] = useState('');
    const [os, setOs] = useState('');

    useEffect(() => {
    //   const fetchIpAddress = async () => {
    //     const response = await fetch('/api/get-ip');
    //     const data = await response.json();
    //     setIpAddress(data.ipAddress);        
    //   };

    axios.get('https://api.ipify.org?format=json')
      .then(response => {
        setIpAddress(response.data.ip);
      })
      .catch(err => {
        // setError('Error fetching IP address');
        console.error(err);
      });

      setUserAgent(navigator.userAgent);

    // Get the platform (e.g., Windows, Mac, Linux, iOS, Android)
    setPlatform(navigator.platform);

    // Get the preferred language of the user
    setLanguage(navigator.language);

    // Extract the operating system from the user agent string
    const userAgentString = navigator.userAgent.toLowerCase();
    if (userAgentString.includes('windows')) {
      setOs('Windows');
    } else if (userAgentString.includes('mac')) {
      setOs('Mac OS');
    } else if (userAgentString.includes('linux')) {
      setOs('Linux');
    } else if (userAgentString.includes('iphone') || userAgentString.includes('ipad')) {
      setOs('iOS');
    } else if (userAgentString.includes('android')) {
      setOs('Android');
    } else {
      setOs('Unknown');
    }
  
    //   fetchIpAddress();
    }, []);

    const handleChange = (event) => {
        if (event.target.name === 'username') {
            setValidUser(true)
            setUsername(event.target.value)
        }
        if (event.target.name === 'password') {
            setValidPassword(true)
            setPassword(event.target.value)
        }
    }


    const navigate = useNavigate();
    const auth = useAuth();
    const location = useLocation();

    const redirectPath = location.state?.pathname || '/'


    useEffect(() => {
        setLoader(false);
    }, []);

    useEffect(() => {
        if (props.LOGINREDUCER.ISAUTH) {
            auth.login({ ...props.LOGINREDUCER.USER })
            navigate(redirectPath)
        } else {
            navigate('/login')
        }
        setLoader(false);
    }, [props.LOGINREDUCER])

    const handleSubmit = (event) => {
        event.preventDefault();
        let params = {
            username: username,
            password: password,
            ipAddress: ipAddress,
            userAgent: userAgent,
            platform: platform,
            language: language,
            os: os
        }

        console.log('Info : {} ', params)

        if (username && username.length && password && password.length) {
            setLoader(true);
            props.startLogin(params)
        } else {
            if (!username && !username.length) {
                setValidUser(false);
            }
            if (!password && !password.length) {
                setValidPassword(false)
            }
        }
    }


    return (
        <div className="login login-v1">
            <div className="login-container">
                <div className="login-header">
                    <div className="brand">
                        <div className="d-flex align-items-center">
                            <span className="logo"></span> <b>Station Reports</b>
                        </div>
                    </div>
                    <div className="icon">
                        <i className="fa fa-lock"></i>
                    </div>
                </div>
                <div className="login-body">
                    <div className="login-content fs-13px">
                        <form onSubmit={handleSubmit}>
                            <label htmlFor="username" className="d-flex align-items-center py-0">Username</label>
                            <div className="form-floating mb-20px">
                                <input type="username" className="form-control fs-5 h-15px" name="username" placeholder="username" onChange={handleChange} />
                            </div>
                            <label htmlFor="password" className="d-flex align-items-center py-0">Password</label>
                            <div className="form-floating mb-20px">
                                <input type= { showPassword ? "text" :  "password" } className="form-control fs-15px h-35px" name="password" placeholder="password" onChange={handleChange} />
                            </div>
                            <div className="form-check mb-20px">
									<input className="form-check-input" type="checkbox" value="" id="rememberMe" checked= {showPassword} onChange={() => {setShowPassword(!showPassword)}}/>
									<label className="form-check-label" htmlFor="rememberMe">
										Show Password
									</label>
								</div>

                            <div className="login-buttons">
                                <button type="submit" className="btn h-45px btn-success d-block w-100 btn-lg">Sign me in</button>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    return state
}

const mapDispatchToProps = {
    startLogin
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginComponent);